module.exports = __webpack_public_path__ + "img/cabin-side.a7ed8ec9.webp";